import { ref } from 'vue'
import { defineStore } from 'pinia'
import { dashboardApi } from '../api/dashboard.api'
import type { MetricActionRequest, MetricDeliveryStatusRequest } from '../api/dashboard.requests'
import type {
  ActionSetting,
  DeliveryStatusSetting,
  MetricAction,
  MetricDeliveryStatus,
} from '../models/dashboard.model'

export const useDashboardStore = defineStore('dashboard', () => {
  const actions = ref<MetricAction[]>([])
  const deliveryStatus = ref<{ [id: number]: MetricDeliveryStatus }>()
  const deliveryStatusSettings = ref<DeliveryStatusSetting[]>([])
  const actionSettings = ref<ActionSetting[]>([])
  const total = ref<number>(0)

  const loadMetricSettings = async () => {
    const response = await dashboardApi.getMetricSettings()

    if (!response.error && response.data) {
      deliveryStatusSettings.value = response.data.deliveryStatusSettings
      actionSettings.value = response.data.actionSettings
    }
  }

  const loadMetricActions = async (body: MetricActionRequest): Promise<boolean> => {
    const response = await dashboardApi.getMetricActions(body)

    if (!response.error && response.data) {
      actions.value = response.data
      return true
    }

    return false
  }

  const loadMetricDeliveryStatus = async (body: MetricDeliveryStatusRequest): Promise<boolean> => {
    const response = await dashboardApi.getMetricDeliveryStatus(body)

    if (!response.error && response.data) {
      deliveryStatus.value = response.data.status
      total.value = response.data.total
      return true
    }

    return false
  }

  return {
    total,
    actions,
    actionSettings,
    deliveryStatus,
    deliveryStatusSettings,
    loadMetricSettings,
    loadMetricActions,
    loadMetricDeliveryStatus,
  }
})
